const URL_PROD = 'https://peer-api.herokuapp.com';
const URL_DEV = 'http://192.168.254.200:3001';

const secret = {
  API_URL: `${URL_PROD}/api/v1`
};

export default secret;


// WEBPACK FOOTER //
// ./src/secret.js